import BaseAdapter from './base';
import {AxiosResponse, AxiosError} from 'axios';
import Upload from "@/models/Upload";
import featureFlags from "@/util/featureFlags";

export default class DownloadAdapter extends BaseAdapter {

  public downloadMetadata(id: string): Promise<Upload> {
    return new Promise(((resolve, reject) => {
      const url = `/downloads/${id}`;
      this.request({
        method: 'get',
        url,
      }).then( (res: AxiosResponse) => {
        resolve(res.data);
      }).catch((error: AxiosError) => {
        reject(error);
      });
    }));

  }

  public downloadChunk(uploadId: string, chunkId: string, onDownloadProgress:
      (progressEvent: {loaded: number, total: number}) => void ):
      Promise<ArrayBuffer> {
    return new Promise(((resolve, reject) => {

        try {
            const url = `/downloads/${uploadId}/chunks/${chunkId}`;

            if ('fetch' in self) {
                const completeUrl = featureFlags.backendBaseUrl + '/api/v1' + url;
                fetch(completeUrl).then( (response: Response) => {

                    if (!response || !response.ok) {
                        reject(new Error("Response is not there or not okay"));
                        return;
                    } //Error!

                    if (!response.body) {
                        reject(new Error("Response body is not there"));
                        return;
                    } // either no content or readable stream not supported

                    const contentLength: string = response.headers.get('content-length') || "call failed";
                    if (!contentLength || contentLength === "call failed") {
                        reject(new Error("Content Length header is not present"));
                        return;
                    }

                    const total: number = parseInt(contentLength, 10);
                    let loaded: number = 0;
                    const reader = response.body.getReader();

                    async function readStream() {
                        const bytes: Uint8Array = new Uint8Array(total);

                        let done = false;

                        while (!done) {
                            try {
                                const result = await reader.read();
                                done = result.done;
                                if (done) { break; } //early exit, when done value = null!
                                const value = result.value;
                                bytes.set(value, loaded);
                                loaded += value.length;
                                onDownloadProgress({ loaded, total});
                            } catch (e) {
                                reject(e);
                            }
                        }

                        return bytes;
                    }

                    readStream().then((bytes) => {
                        if (loaded !== total) {
                            reject(new Error("Received bytes and content length header do not equal"));
                            return;
                        }
                        resolve(bytes);
                    });


                }).catch((err) => {
                    reject(err);
                } );
            } else {
                return this.request({
                    method: 'get',
                    url,
                    headers: {
                        Accept: 'application/octet-stream',
                    },
                    responseType: 'arraybuffer',
                    onDownloadProgress,
                }).then((res: AxiosResponse) => {
                    resolve(res.data);
                }).catch((error: AxiosError) => {
                    reject(error);
                });
            }
        } catch (e) {
            reject(e);
        }
    }));
  }
}
